// page-actions/matrix-mode.ts — Mode matrice Eisenhower de #actions : rendu à
// la place du tableau et CTA de bascule liste ↔ matrice.
//
// Cinquième tranche extraite de `renderActionsPage` (point 16, 2026-09-08).
// La page garde l'état (`viewMode`, seuils), la persistance URL et la
// sélection ; ici seulement la glu DOM autour de matrix-view.ts.
//
// Globaux ambiants : t, todayStr (core-globals.d.ts).

import { consumeLastModifiedAnimation } from '../../utils/last-modified-anim.js';
import { renderMatrixInto, type MatrixViewOpts } from './matrix-view.js';

export interface MatrixModeContext {
  actions: MatrixViewOpts['actions'];
  thresholds: MatrixViewOpts['thresholds'];
  statusMap: MatrixViewOpts['statusMap'];
  userMap: MatrixViewOpts['userMap'];
  /** Déplacement d'un curseur : la page mémorise et persiste les seuils. */
  onThresholdsChange: MatrixViewOpts['onChange'];
  /** Clic sur une carte : la page marque vue et ouvre l'éditeur. */
  onOpen: MatrixViewOpts['onOpenAction'];
}

/**
 * Rend la matrice dans `el`. La bulk-bar (sélection, fusion) est propre à la
 * liste : elle est vidée. Au retour d'édition, la chip modifiée clignote comme
 * la ligne le ferait en liste.
 */
export function renderMatrixMode(el: HTMLElement, ctx: MatrixModeContext): void {
  const bb = document.getElementById('act-bulk-bar');
  if (bb) bb.innerHTML = '';
  renderMatrixInto(el, {
    actions: ctx.actions,
    today: todayStr(),
    thresholds: ctx.thresholds,
    statusMap: ctx.statusMap,
    userMap: ctx.userMap,
    onChange: ctx.onThresholdsChange,
    onOpenAction: ctx.onOpen,
  });
  setTimeout(() => {
    consumeLastModifiedAnimation('actions', (id) =>
      el.querySelector<HTMLElement>(`[data-action-id="${id}"]`),
    );
  }, 50);
}

/** Reflète l'état liste/matrice sur le CTA du header (libellé + style actif). */
export function updateMatrixToggle(active: boolean): void {
  const btn = document.getElementById('btn-actions-matrix');
  if (!btn) return;
  btn.setAttribute('aria-pressed', active ? 'true' : 'false');
  // Actif = bouton plein (vert) ; inactif = style .btn-secondary par défaut.
  btn.style.background = active ? 'var(--accent)' : '';
  btn.style.color = active ? '#fff' : '';
  const label = document.getElementById('btn-actions-matrix-label');
  if (label)
    label.textContent = active ? t('pageActions.btn.listView') : t('pageActions.btn.matrix');
}

/**
 * Câble le CTA « Matrice Eisenhower » du header, présent seulement avec la
 * permission actions.matrix. `onToggle` bascule l'état côté page et re-rend ;
 * le CTA est resynchronisé après.
 */
export function wireMatrixToggle(isActive: () => boolean, onToggle: () => void): void {
  const btn = document.getElementById('btn-actions-matrix');
  if (!btn) return;
  updateMatrixToggle(isActive());
  btn.addEventListener('click', () => {
    onToggle();
    updateMatrixToggle(isActive());
  });
}
